
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9 2.594l1.719 1.688 16.125 16.156-7.094.875 1.844 3.625.438.906-.875.438-4 2.063-.438-.906-2.031-4.031-4.031 3.375-1.656 1.375V2.595zm2 4.844v16.406l4.313-3.625.594 1.125 2.156 4.313 1.313-.688-2.063-4-.656-1.281 1.406-.188 4.5-.531z"}})])
          )
        }
      }
    